import BaseCtrl from 'edge/platform/base/BaseCtrl';

export default (function () {
    var ctrlConstructor = function ctrlConstructor($scope, MediaQueriesUtil, $element) {
        // indicator to prevent a slide panel closing on opener element click
        // when opener is in a content section
        var drawerIsOpening = false;
        var drawerIsOpenPostfix = 'DrawerIsOpen';
        var mediaQuery = MediaQueriesUtil.getPhoneLandscapeDownQuery();

        var ctrl = Object.create(BaseCtrl);

        ctrl.init = function () {
            $scope['left' + drawerIsOpenPostfix] = false; // leftDrawerIsOpen
            $scope['right' + drawerIsOpenPostfix] = false; // rightDrawerIsOpen

            ctrl._breakpointReached(mediaQuery);

            // EVENTS
            mediaQuery.addListener(ctrl._breakpointReached);

            $element.on('click', function () {
                if (drawerIsOpening) {
                    drawerIsOpening = false;
                    return;
                }
                ctrl.closeDrawers();
            });

            // remove listeners on $scope destroying
            $scope.$on('$destroy', function () {
                mediaQuery.removeListener(ctrl._breakpointReached);
                ctrl._retrieveContentFocus();
                $element.off('click');
            });
        };

        /**
         * @param {String} drawerSide 'left' || 'right'
         */
        ctrl.openDrawer = function (drawerSide) {
            // close other
            var otherDrawerSide = ctrl._getOtherDrawerSide(drawerSide);
            if ($scope[otherDrawerSide + drawerIsOpenPostfix]) {
                ctrl.closeDrawer(otherDrawerSide);
            }
            // open current
            $element.addClass('gw-snap-drawer-' + drawerSide + '-active');
            ctrl._preventContentFocus();

            drawerIsOpening = true;
            $scope[drawerSide + drawerIsOpenPostfix] = true; // set drawer state to $scope
        };

        /**
         * @param {String} drawerSide 'left' || 'right'
         */
        ctrl.closeDrawer = function (drawerSide) {
            $element.removeClass('gw-snap-drawer-' + drawerSide + '-active');
            ctrl._retrieveContentFocus();

            $scope[drawerSide + drawerIsOpenPostfix] = false; // set drawer state to $scope
        };

        ctrl.closeDrawers = function () {
            if ($scope['left' + drawerIsOpenPostfix]) {
                ctrl.closeDrawer('left');
                ctrl._angularApply();
            }

            if ($scope['right' + drawerIsOpenPostfix]) {
                ctrl.closeDrawer('right');
                ctrl._angularApply();
            }
        };

        // UTILS
        ctrl._getOtherDrawerSide = function (drawerSide) {
            switch (drawerSide) {
                case 'left':
                    return 'right';
                case 'right':
                    return 'left';
                default:
                    break;
            }
        };

        // Required when some functionality is called outside of AngularJs
        ctrl._angularApply = function () {
            if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                $scope.$apply();
            }
        };

        /* EVENT */
        // PREVENT SCROLLING AND FOCUS INSIDE ELEMENTS WHEN DRAWER IS OPEN
        ctrl._preventContentFocus = function () {
            $element.on('focusin.snap', function (e) {
                return $(e.target).blur();
            });
        };

        ctrl._retrieveContentFocus = function () {
            $element.off('focusin.snap');
        };

        // media query change
        ctrl._breakpointReached = function () {
            if (!mediaQuery.matches) {
                // >= break
                ctrl.closeDrawers(); // close drawers on switching from a mobile to a bigger screen
            }
        };

        return ctrl.create($scope);
    };
    ctrlConstructor.$inject = ['$scope', 'MediaQueriesUtil', '$element'];

    return {
        restrict: 'A',
        replace: false,
        controller: ctrlConstructor
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/pagestructure/directives/PageDrawerSlideoutDirective.js
// module id = 1141
// module chunks = 0